import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / ListItem`}</p>
    <h1 {...{
      "id": "interface-listitem"
    }}>{`Interface: ListItem`}</h1>
    <p>{`Base interface for any item that can be used in `}<a parentName="p" {...{
        "href": "../classes/ItemList.md"
      }}>{`ItemList`}</a>{`. ItemList is used in different places to hold various
types of items, including Nodes, Fills, and Strokes.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      